if (!customElements.get('aplovio-localization')) {
  customElements.define('aplovio-localization',class extends HTMLElement {
    connectedCallback() {
      if(this.abort)return;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.form=this.querySelector('form');this.dialog=this.closest('dialog');
      this.country=this.querySelector('select[name=country_code]');
      this.picker=this.querySelector('[data-country-picker]');
      if(this.country && this.picker){
        this.button=this.querySelector('[data-country-open]');this.menu=this.querySelector('[data-country-menu]');
        this.search=this.querySelector('[data-country-search]');this.items=[...this.querySelectorAll('[data-country-option]')];
        this.country.hidden=true;this.picker.hidden=false;
        this.querySelector('[data-country-label]').htmlFor=this.button.id;
        this.button.addEventListener('click',()=>this.menu.hidden?this.openCountries():this.closeCountries(true),options);
        this.search.addEventListener('input',()=>this.filterCountries(),options);
        this.picker.addEventListener('keydown',event=>{
          if(event.key==='Escape' && !this.menu.hidden){event.preventDefault();event.stopPropagation();this.closeCountries(true);return;}
          if(this.menu.hidden && ['ArrowDown','ArrowUp'].includes(event.key)){event.preventDefault();this.openCountries();return;}
          if(this.menu.hidden)return;
          const visible=this.items.filter(item=>!item.hidden);let index=visible.indexOf(this.active);
          if(['ArrowDown','ArrowUp','Home','End'].includes(event.key)){
            event.preventDefault();index=event.key==='Home'?0:event.key==='End'?visible.length-1:event.key==='ArrowDown'?Math.min(visible.length-1,index+1):Math.max(0,index-1);
            this.activateCountry(visible[index]);
          } else if(event.key==='Enter'){event.preventDefault();if(this.active)this.chooseCountry(this.active);}
        },options);
        this.menu.addEventListener('pointerdown',event=>{if(event.target.closest('[data-country-option]'))event.preventDefault();},options);
        this.menu.addEventListener('click',event=>{const item=event.target.closest('[data-country-option]');if(item && !item.hidden)this.chooseCountry(item);},options);
        this.picker.addEventListener('focusout',event=>{if(!this.picker.contains(event.relatedTarget))this.closeCountries(false);},options);
      }
      this.dialog.addEventListener('aplovio:layer-open',event=>{if(event.target===this.dialog){this.form.reset();this.syncCountry();this.closeCountries(false);}},options);
      this.dialog.addEventListener('aplovio:layer-close',event=>{if(event.target===this.dialog){this.form.reset();this.syncCountry();this.closeCountries(false);}},options);
    }
    syncCountry() {
      if(!this.country)return;
      this.querySelector('[data-country-current]').textContent=this.country.selectedOptions[0]?.textContent || '';
      this.items.forEach(item=>item.setAttribute('aria-selected',String(item.dataset.countryOption===this.country.value)));
    }
    openCountries() {
      this.menu.hidden=false;this.button.setAttribute('aria-expanded','true');this.search.setAttribute('aria-expanded','true');
      this.search.value='';this.filterCountries();this.activateCountry(this.items.find(item=>item.dataset.countryOption===this.country.value));
      this.search.focus({preventScroll:true});
    }
    closeCountries(focus) {
      if(!this.menu)return;
      this.menu.hidden=true;this.button.setAttribute('aria-expanded','false');this.search.setAttribute('aria-expanded','false');this.search.removeAttribute('aria-activedescendant');
      if(focus)this.button.focus({preventScroll:true});
    }
    filterCountries() {
      const normalize=value=>value.normalize('NFD').replace(/\p{Diacritic}/gu,'').toLocaleLowerCase();
      const query=normalize(this.search.value.trim());
      this.items.forEach(item=>item.hidden=!normalize(`${item.textContent} ${item.dataset.countryOption}`).includes(query));
      const visible=this.items.filter(item=>!item.hidden);this.querySelector('[data-country-empty]').hidden=visible.length>0;
      this.activateCountry(visible[0]);
    }
    activateCountry(item) {
      this.items.forEach(option=>option.toggleAttribute('data-active',option===item));this.active=item;
      if(!item){this.search.removeAttribute('aria-activedescendant');return;}
      this.search.setAttribute('aria-activedescendant',item.id);
      const list=item.parentElement,bounds=list.getBoundingClientRect(),row=item.getBoundingClientRect();
      if(row.top<bounds.top)list.scrollTop-=bounds.top-row.top;else if(row.bottom>bounds.bottom)list.scrollTop+=row.bottom-bounds.bottom;
    }
    chooseCountry(item) {
      this.country.value=item.dataset.countryOption;this.country.dispatchEvent(new Event('change',{bubbles:true}));this.syncCountry();this.closeCountries(true);
    }
    disconnectedCallback(){this.abort?.abort();this.abort=null;}
  });
}
